import './index.css'
import * as React from 'react'

const LoadingMore = (): React.ReactElement<'div'> => {
  return <div className="ExplorerPane_LoadMore">Loading...</div>
}

export default LoadingMore
